import { render, staticRenderFns } from "./SCROMPlayer.vue?vue&type=template&id=3f515094&scoped=true&"
import script from "./SCROMPlayer.vue?vue&type=script&lang=js&"
export * from "./SCROMPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f515094",
  null
  
)

export default component.exports